export const ONSET_AUDIT_PROJECT_ID = '0c47b21b-0121-41d1-8523-8b22bf5c0b64';

export const ONSET_AUDIT_RULE_SCORE = 0.6;

export const ONSET_AUDIT_DURATION_CEILING_SECONDS = 10 * 60;

export interface OnsetAuditTrack {
  readonly id: string;
  readonly title: string;
  readonly rank: number;
  readonly audioUrl: string;
  readonly impactScore: number;
}

export type OnsetAuditFilter = 'all' | 'violates' | 'does-not-violate';

export interface DurationRange {
  readonly minimum: number;
  readonly maximum: number;
}

export function formatDurationInput(seconds: number) {
  const wholeSeconds = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(wholeSeconds / 60);
  return `${minutes}:${String(wholeSeconds % 60).padStart(2, '0')}`;
}

export function parseDurationInput(value: string) {
  const match = /^(\d+):([0-5]\d)$/.exec(value.trim());
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}

export function durationIsInRange(durationSeconds: number | null, range: DurationRange) {
  if (durationSeconds === null) return true;
  return durationSeconds >= range.minimum && durationSeconds <= range.maximum;
}

export function violatesOnsetAuditRule(track: OnsetAuditTrack) {
  return track.impactScore >= ONSET_AUDIT_RULE_SCORE;
}

export function filterOnsetAuditTracks(
  tracks: readonly OnsetAuditTrack[],
  options: { readonly filter: OnsetAuditFilter; readonly query: string },
) {
  const normalizedQuery = options.query.trim().toLocaleLowerCase();
  return tracks.filter((track) => {
    if (normalizedQuery && !track.title.toLocaleLowerCase().includes(normalizedQuery)) return false;
    const violates = violatesOnsetAuditRule(track);
    if (options.filter === 'violates') return violates;
    if (options.filter === 'does-not-violate') return !violates;
    return true;
  });
}
